import { useRef, useState } from "react";

export const useUsageGuideDialogHooks = () => {
  const mainRef = useRef<HTMLDivElement>(null);
  const [expand, setExpand] = useState(true);

  return { mainRef, expand, setExpand } as const;
};
